import {
  LayoutDashboard,
  Phone,
  User,
  Settings,
  CreditCard,
  PieChart,
  Plug,
  UserCircle,
  Building,
} from "lucide-react";
import Dashboard from "./Dashboard/Analytics";
import SubAccounts from "./SubAccounts";
import Users from "./Users";
import SaasConfigurator from "./SaasConfigurator";
import FBDashboard from "./PhoneBridge/dashboard";
import FBSubAccounts from "./PhoneBridge/subaccounts";
import Billing from "./Billing";
import Reselling from "./Reselling";
import Integrations from "./Integrations";
import UserProfile from "./UserProfile";
import ConfigurePlan from "./SaasConfigurator/plans/ConfigurePlan";

export default function useRoutes() {
  return [
    {
      id: "dashboard",
      icon: <LayoutDashboard />,
      path: "/dashboard",
      title: "Dashboard",
      component: <Dashboard />,
    },
    {
      id: "sub_accounts",
      icon: <Building />,
      path: "/sub_accounts",
      title: "Sub Accounts",
      checkPermission: true,
      component: <SubAccounts />,
    },
    {
      id: "team",
      icon: <User />,
      path: "/team",
      title: "Team",
      checkPermission: true,
      component: <Users />,
    },
    {
      id: "saas_configurator",
      icon: <Settings />,
      path: "/saas_configurator",
      title: "Saas Configurator",
      checkPermission: true,
      component: <SaasConfigurator />,
      subItems: [
        {
          parentId: "saas_configurator",
          id: "configure-plan",
          path: "/configure-plan",
          checkPermission: false,
          component: <ConfigurePlan />,
        },
        {
          parentId: "saas_configurator",
          id: "configure-plan",
          path: "/configure-plan/:planId",
          checkPermission: false,
          component: <ConfigurePlan />,
        },
      ],
    },
    {
      id: "phone_bridge",
      icon: <Phone />,
      path: "/phone_bridge",
      title: "Phone Bridge",
      checkPermission: true,
      isCollapse: true,
      subItems: [
        {
          parentId: "phone_bridge",
          id: "dashboard",
          path: "/dashboard",
          title: "Dashboard",
          checkPermission: true,
          component: <FBDashboard />,
        },
        {
          parentId: "phone_bridge",
          id: "sub_accounts",
          path: "/sub_accounts",
          title: "Sub Accounts",
          checkPermission: true,
          component: <FBSubAccounts />,
        },
      ],
    },
    {
      id: "billing",
      icon: <CreditCard />,
      path: "/billing",
      title: "Billing",
      checkPermission: true,
      component: <Billing />,
    },
    {
      id: "re_selling",
      icon: <PieChart />,
      path: "/re_selling",
      title: "Reselling",
      checkPermission: true,
      component: <Reselling />,
    },
    {
      id: "integrations",
      icon: <Plug />,
      path: "/integrations",
      title: "Integrations",
      checkPermission: true,
      component: <Integrations />,
    },
    {
      id: "settings",
      icon: <Settings />,
      path: "/settings",
      target: "/user-profile",
      title: "Settings",
      checkPermission: false,
      isIsolatedMenu: true,
      subItems: [
        {
          parentId: "settings",
          id: "user-profile",
          icon: <UserCircle />,
          path: "/user-profile",
          title: "User Profile",
          checkPermission: false,
          component: <UserProfile />,
        },
      ],
    },
  ];
}
